import { render, staticRenderFns } from "./IdeaSubmit.vue?vue&type=template&id=691decc4&scoped=true&"
import script from "./IdeaSubmit.vue?vue&type=script&lang=js&"
export * from "./IdeaSubmit.vue?vue&type=script&lang=js&"
import style0 from "./IdeaSubmit.vue?vue&type=style&index=0&id=691decc4&lang=scss&scoped=true&"
import style1 from "./IdeaSubmit.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691decc4",
  null
  
)

export default component.exports